import { Component, TemplateRef } from '@angular/core';
import { ToastsService } from '../../services/toasts.service';


@Component({
  selector: 'safetydirector-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.css']
})
export class ToastsContainer {
  constructor(public toastService: ToastsService) { }

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }
}
